var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayPlus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40881 10C1.40881 9.22181 2.03968 8.59094 2.8179 8.59094H15.7708C16.549 8.59094 17.1799 9.22181 17.1799 10C17.1799 10.7783 16.549 11.4091 15.7708 11.4091H2.8179C2.03968 11.4091 1.40881 10.7783 1.40881 10Z",
    fill: "#78829D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29428 17.8856C10.0725 17.8856 10.7034 17.2547 10.7034 16.4765V3.52356C10.7034 2.74534 10.0725 2.11447 9.29428 2.11447C8.51606 2.11447 7.88519 2.74534 7.88519 3.52356V16.4765C7.88519 17.2547 8.51606 17.8856 9.29428 17.8856Z",
    fill: "#78829D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayPlus);
export default ForwardRef;